import { createStore } from 'vuex'
import donationWidget from './modules/donation-widget'
import campaignWidget from './modules/campaign-widget';

export const store = createStore({
      modules: {
        donationWidget,
        campaignWidget,
      },
})
